import { Button, Buttons, CancelButton, Field, Form, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { Formik } from 'formik';
import { useForm } from '~/hooks';
import React, { useRef } from 'react';
import { ErrorPage } from '~/routes/public/pages';
import { dateFormats, emptyStringToNull } from '~/utils';
import * as Yup from 'yup';
import moment from 'moment';

function ProjectHealthReportCloneForm({ id, projectId, onClose, onSaved }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [{ status, message, isSubmitting }, form] = useForm();
  const formRef = useRef();

  async function handleSubmit(values) {
    try {
      form.submit();
      const body = emptyStringToNull({
        ...values,
      });

      const { data } = await api.www.workspaces(workspace.id).projects(projectId).healthReports(id).clone(body);
      await onSaved(data);
      form.done();
    } catch ({ message }) {
      form.error({ message });
    }
  }

  if (!id) return <ErrorPage.NotFound publicSite={false} />;

  const initialValues = {
    date: moment().format(dateFormats.isoDate),
  };

  return (
    <ModalCard title="Clone Project Health Report" onClose={onClose}>
      <Formik
        innerRef={formRef}
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          date: Yup.date().label('New Project Health Report Date').nullable().required(),
        })}>
        {() => {
          return (
            <Form>
              <ModalCard.Body>
                <Form.Control>
                  <Field.DayPicker name="date" placeholder="New Project Health Report Date" clearable={false} />
                </Form.Control>
                {status && <FormMessage.Error>{message || 'An error has occurred.'}</FormMessage.Error>}
              </ModalCard.Body>
              <ModalCard.Footer>
                <Buttons align="right">
                  <CancelButton onClick={onClose}>Close</CancelButton>
                  <Button type="submit" isLoading={isSubmitting}>
                    Save
                  </Button>
                </Buttons>
              </ModalCard.Footer>
            </Form>
          );
        }}
      </Formik>
    </ModalCard>
  );
}

export default ProjectHealthReportCloneForm;
